<div class="flex w-full mt-5 pr-2">
  <modus-label class="text-xs grow">{{ translations.blendIntensity.text }}</modus-label>
  <modus-switch
    id="3d-settings-classification-intensity-toggle"
    [formControl]="blendIntensityControl"
  ></modus-switch>
</div>

@if (showIntensitySettings()) {
  <sd-scan-3d-intensity
    [scan3dStyle]="scan3dStyle()"
    (styleChange)="onStyleChange($event)"
    class="mb-2"
  ></sd-scan-3d-intensity>
}

<ol class="mt-3">
  @for (item of classificationSchemes(); track item.id) {
    <li class="flex items-center text-xs p-y-2 pr-2 mb-2 border-y border-gray-1 border-opacity-40">
      <button
        id="3d-global-settings-classification-item-visible-toggle"
        class="min-w-8"
        modus-icon-button
        (click)="changeVisibility(item)"
      >
        <md-icon class="!text-xl" [ngClass]="{ 'opacity-60': !item.visible }">{{
          item.visible ? 'visibility_on' : 'visibility_off'
        }}</md-icon>
      </button>
      <span class="grow overflow-hidden text-ellipsis whitespace-nowrap pl-1">
        {{ item.name }}
      </span>
      <div class="ml-2 h-4 w-9 flex-shrink-0">
        <sd-color-picker
          [color]="item.rgba"
          [dialogPosition]="'auto'"
          [dialogSize]="'medium'"
          (colorChanged)="changeColor($event, item)"
        ></sd-color-picker>
      </div>
    </li>
  }
</ol>
